import Vue from 'vue'
// Use it to import all Vue file containing this folder as Components
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key =>Vue.component(key.split('/').pop().split('.')[0], files(key).default))



// to reduce app.js file size
// should use () => import('') instead of required('').default


const components = {
    'not_found': './utility/404.vue',
    'file_not_found': './utility/file_not_found.vue',
    'assetflow-files-file-import-export': './assetflow/files/FileImport.vue',
    'assetflow-files-pdf-to-xlsx': './assetflow/files/PdfToXlsx.vue',
    'home': './Dashboard.vue',
    'af_dashboard': './Dashboard.vue',
    'login': './account/login-2.vue',
    'login-carousel': './account/LoginCarousel.vue',
    'register': './account/register.vue',
    'assetflow-icons-boxicons': './assetflow/customers/icons/boxicons.vue',
    'assetflow-icons-dripicons': './assetflow/customers/icons/dripicons.vue',
    'assetflow-icons-materialdesign': './assetflow/customers/icons/materialdesign.vue',
    'assetflow-icons-fontawesome': './assetflow/customers/icons/fontawesome.vue',
    'forgot-password': './account/forgot-password.vue',
    'reset-password': './account/reset-password.vue',
    'quick_actions': './assetflow/AssetMenu/AddAssetMenu.vue',
    'assetflow-recycle_bin': './assetflow/recycle_bin/RecycleBin.vue',
    'assetflow-currencies': './assetflow/settings/CustomerExchangeRates.vue',
    'viewItem': './assetflow/items/View.vue',
    'customer-changes-scene': './assetflow/items/View.vue',
    'customer-overview': './assetflow/customers/Overview.vue',
    'assetflow-customers-assets_dashboard': './assetflow/customers/Dashboards/Dashboard.vue',
    'assetflow-customers-sto_dashboard': './assetflow/customers/Dashboards/StoDashboard.vue',
    'assetflow-addresses': './assetflow/customers/addresses/List.vue',
    'assetflow-addresses-new': './assetflow/customers/addresses/New.vue',
    'assetflow-addresses-edit': './assetflow/customers/addresses/New.vue',
    'assetflow-suppliers': './assetflow/customers/suppliers/List.vue',
    'assetflow-events': './assetflow/customers/events/List.vue',
    'assetflow-asset_groups': './assetflow/customers/asset_groups/List.vue',
    'assetflow-orders': './assetflow/customers/orders/List.vue',
    'assetflow-orders-new': './assetflow/customers/orders/New.vue',
    'assetflow-orders-edit': './assetflow/customers/orders/New.vue',
    'assetflow-orders-process': './assetflow/customers/orders/Process.vue',
    'assetflow-orders-confirm': './assetflow/customers/orders/ConfirmOrder.vue',
    'assetflow-order_setup': './assetflow/customers/orders/NotifiedUserList.vue',
    'assetflow-admin_tools': './assetflow/customers/managed_storages/AdminTools.vue',
    'assetflow-order_lines-new': './assetflow/customers/order_lines/AddOrReturnIntakeToStorage.vue',
    'assetflow-order_lines-return_to_storage': './assetflow/customers/order_lines/AddOrReturnIntakeToStorage.vue',
    'assetflow-order_lines-planned_assets': './assetflow/customers/order_lines/AddOrReturnIntakeToStorage.vue',
    'assetflow-orders-storage_orders': './assetflow/customers/orders/List.vue',
    'assetflow-orders-move_to_storage': './assetflow/customers/orders/List.vue',
    'assetflow-order_lines-storage_orders': './assetflow/customers/order_lines/List.vue',
    'assetflow-order_lines-move_to_storage': './assetflow/customers/order_lines/List.vue',
    'assetflow-managed_storages-dispatched': './assetflow/customers/managed_storages/List.vue',
    'assetflow-managed_storages-in_progress': './assetflow/customers/managed_storages/List.vue',
    'assetflow-managed_storages-in_storage': './assetflow/customers/managed_storages/List.vue',
    'assetflow-order_lines': './assetflow/customers/order_lines/List.vue',
    'assetflow-managed_storages': './assetflow/customers/managed_storages/List.vue',
    'assetflow-activity_logs': './assetflow/customers/activity_log/List.vue',
    'assetflow-bulk_updates': './assetflow/customers/bulk_updates/List.vue',
    'assetflow-bulk_updates-user': './assetflow/customers/bulk_updates/List.vue',
    'assetflow-ledgers': './assetflow/customers/ledgers/List.vue',
    // Assets Film & TV, Pass 1 Part A, slice 6 (R9, section 5's "Ledger import" row): the page at
    // /<entity>/ledgers/import. `CustomerController@showPage` joins the component and the action
    // with a hyphen, which is what makes the key `assetflow-ledgers-import`.
    'assetflow-ledgers-import': './assetflow/customers/ledgers/LedgerImport.vue',
    // Assets Film & TV, D9/D1 part 1: the departments import page at /<entity>/departments/import,
    // mounted the way the chart import page is -- the same hyphen-joined key, matched by the generic
    // /{component}/{action} route and never declared as its own route in routes/web.php.
    'assetflow-departments-import': './assetflow/customers/departments/DepartmentImport.vue',
    /*
     * Assets Film & TV, Pass 1 Part A, slice 7 (section 5, the "Ledgers list and form" row): the
     * module's OWN ledgers page at /<entity>/ledgers/accounts. The key is built the same way the
     * import's is — `CustomerController@showPage` joins the component and the action with a hyphen.
     *
     * The shared `/ledgers` page above keeps `List.vue` untouched: REFERENCE_LEDGERS.md section 8
     * lists what that screen and its modal do wrong and says it must not be extended, and every other
     * module that uses ledgers still points at it.
     */
    'assetflow-ledgers-accounts': './assetflow/customers/ledgers/AccountsList.vue',
    'assetflow-ledger_groups': './assetflow/customers/ledger_groups/List.vue',
    'assetflow-characters': './assetflow/customers/characters/List.vue',
    'assetflow-sets': './assetflow/customers/sets/List.vue',
    'assetflow-scenes': './assetflow/customers/scenes/List.vue',
    'assetflow-scripts': './assetflow/customers/scripts/List.vue',
    'assetflow-shoot-day-live': './assetflow/customers/ShootDayLive/Dashboard.vue',
    'assetflow-changes': './assetflow/customers/changes/List.vue',
    'assetflow-scenes-costume': './assetflow/customers/parts_costume/List.vue',
    'assetflow-scenes-costume-new': './assetflow/customers/parts_costume/New.vue',
    'assetflow-scenes-costume-edit': './assetflow/customers/parts_costume/New.vue',
    'assetflow-parts': './assetflow/customers/parts/List.vue',
    'assetflow-parts-new': './assetflow/customers/parts/New.vue',
    'assetflow-parts-edit': './assetflow/customers/parts/New.vue',
    'assetflow-scene_locations': './assetflow/customers/scene_locations/List.vue',
    'assetflow-payments': './assetflow/customers/payments/List.vue',
    'assetflow-receipts': './assetflow/customers/receipts/List.vue',
    'assetflow-sp_warehouses': './assetflow/customers/sp_warehouses/List.vue',
    'assetflow-sp_spaces': './assetflow/customers/sp_spaces/List.vue',
    'assetflow-sp_assignments': './assetflow/customers/sp_assignments/List.vue',
    'assetflow-sp_storages': './assetflow/customers/sp_storages/List.vue',
    'assetflow-sp_storage_wrappers': './assetflow/customers/sp_storage_wrappers/List.vue',
    'assetflow-sp_locations': './assetflow/customers/sp_locations/List.vue',
    'assetflow-sp_location_types': './assetflow/customers/sp_location_types/List.vue',
    'assetflow-sp_movements': './assetflow/customers/sp_movements/List.vue',
    'assetflow-files': './assetflow/customers/files/List.vue',
    'assetflow-file_imports': './assetflow/customers/file_imports/List.vue',
    'group-asset_passports': './assetflow/customers/asset_passports/List.vue',
    'assetflow-asset_passports': './assetflow/customers/asset_passports/List.vue',
    'assetflow-departments': './assetflow/customers/departments/List.vue',
    'assetflow-purchaseOrders': './assetflow/customers/purchaseOrders/List.vue',
    'assetflow-purchaseOrders-new': './assetflow/customers/purchaseOrders/New.vue',
    'assetflow-purchaseOrders-edit': './assetflow/customers/purchaseOrders/New.vue',
    'assetflow-settings': './assetflow/customers/settings/SettingsTabs.vue',
    'group-settings': './assetflow/customers/settings/GroupSettingsTabs.vue',
    'assetflow-acquisitions': './assetflow/customers/acquisitions/List.vue',
    'assetflow-acquisitions-new': './assetflow/customers/acquisitions/New.vue',
    'assetflow-acquisitions-edit': './assetflow/customers/acquisitions/New.vue',
    'assetflow-dispositions': './assetflow/customers/dispositions/List.vue',
    'assetflow-tags': './assetflow/customers/tags/List.vue',
    'assetflow-folders': './assetflow/customers/folders/List.vue',
    'assetflow-categories': './assetflow/customers/categories/List.vue',
    'assetflow-policies': './assetflow/customers/policies/List.vue',
    'assetflow-policies-new': './assetflow/customers/policies/AddPolicyForm.vue',
    'assetflow-listView': './assetflow/ListViewTest.vue',
    'htmlRenderer': './assetflow/HtmlRenderer.vue',
    'tristHtmlRenderer': './assetflow/TristHtmlRenderer.vue',
    'formTemplate': './assetflow/templates/AssetFormTemplate.vue',
    'chartTest': './assetflow/ChartTest.vue',
    'assetflow-assets-status': './assetflow/assets/List.vue',
    'assetflow-assets-folders': './assetflow/assets/List.vue',
    'assetflow-assetsNoTabs': './assetflow/assets/ListNoTabs.vue',
    'assetflow-assets': './assetflow/assets/List.vue',
    'assetflow-olderassets': './assetflow/assets/List-OLD.vue',
    'assetflow-aflogs': './assetflow/aflogs/List.vue',
    'assetflow-customers': './assetflow/customers/List.vue',
    'assetflow-service_providers': './assetflow/service_providers/List.vue',
    'assetflow-users': './assetflow/users/List.vue',
    'assetflow-buyers': './assetflow/customers/buyers/List.vue',
    'assetflow-roles': './assetflow/roles/List.vue',
    'assetflow-modules': './assetflow/modules/List.vue',
    'assetflow-templates': './assetflow/file_templates/List.vue',
    'sp-assets': './assetflow/assets/List.vue',
    'sp-customers': './assetflow/customers/List.vue',
    'sp-users': './assetflow/users/List.vue',
    'sp-roles': './assetflow/roles/List.vue',
    'sp-roles-edit': './assetflow/roles/New.vue',
    'assetflow-switch': './account/switch.vue',
    'group-switch': './account/switch.vue',
    'character-switch': './account/switch.vue',
    'assetflow-roles-new': './assetflow/roles/New.vue',
    'assetflow-roles-edit': './assetflow/roles/New.vue',
    'assetflow-roles-view': './assetflow/roles/View.vue',
    'assetflow-roles-permissions': './assetflow/roles/PermissionsList.vue',
    'assetflow-users-new_user': './assetflow/users/New.vue',
    'assetflow-users-new': './assetflow/users/Add.vue',
    'assetflow-users-edit': './assetflow/users/New.vue',
    'assetflow-users-view': './assetflow/users/View.vue',
    'assetflow-assets-csv_import': './assetflow/assets/CsvImport.vue',
    'assetflow-assets-new-older': './assetflow/assets/New-old.vue',
    'assetflow-assets-edit-older': './assetflow/assets/New-old.vue',
    'assetflow-assets-new': './assetflow/assets/New.vue',
    'assetflow-assets-new_asset': './assetflow/assets/NewAssetOrBulkPhotoUpload.vue',
    'assetflow-assets-edit_asset': './assetflow/assets/EditAsset.vue',
    'assetflow-assets-bulk_photo_upload': './assetflow/assets/NewAssetOrBulkPhotoUpload.vue',
    'assetflow-assets-image_files_upload': './assetflow/assets/NewAssetOrBulkPhotoUpload.vue',
    'assetflow-assets-upload_assets': './assetflow/assets/NewAssetOrBulkPhotoUpload.vue',
    'assetflow-acquisitions-new_acquisition': './assetflow/customers/acquisitions/NewAssetAcquisition.vue',
    'assetflow-assets-edit': './assetflow/assets/EditAssetChooser.vue',
    'assetflow-assets-admin_new': './assetflow/assets/NewAdmin.vue',
    'assetflow-assets-admin_edit': './assetflow/assets/NewAdmin.vue',
    'assetflow-customers-new': './assetflow/customers/New.vue',
    'assetflow-customers-edit': './assetflow/customers/New.vue',
    'assetflow-customer-view': './assetflow/customers/View.vue',
    'assetflow-groups': './assetflow/groups/List.vue',
    'assetflow-groups-new': './assetflow/groups/New.vue',
    'assetflow-groups-edit': './assetflow/groups/New.vue',
    'assetflow-customer-sp': './assetflow/items/View.vue',
    'assetflow-service_providers-new': './assetflow/service_providers/New.vue',
    'assetflow-service_providers-edit': './assetflow/service_providers/New.vue',
    'assetflow-service_providers-view': './assetflow/service_providers/View.vue',
    'bss-assets': './assetflow/assets/List.vue',
    'profile': './account/profile.vue',
    'my_roles': './account/my_roles.vue',
    'lockscreen': './account/lockscreen.vue',
    'new_signup_wizard': './account/FirstLoginWizard.vue',
    'shall_select_module': './account/SelectAModule.vue',
    'assetflow-sustainability': './sustain/Sustainability.vue',
    'group-assets': './assetflow/assets/GroupAssets.vue',
    'group-customers': './assetflow/customers/List.vue',
    'group-recycle_bin': './assetflow/recycle_bin/RecycleBin.vue',

};

// 🔥 Lazy-load each component with a unique chunk name
Object.entries(components).forEach(([name, path]) => {
    Vue.component(
        name,
        () =>
            import(
                /* webpackChunkName: "[request]" */
                `${path}`
            )
    );
});



// Vue.component('not_found', require('./utility/404').default);
// Vue.component('file_not_found', require('./utility/file_not_found').default);
// Vue.component('assetflow-files-file-import-export', require('./assetflow/files/FileImport').default);
// Vue.component('assetflow-files-pdf-to-xlsx', require('./assetflow/files/PdfToXlsx').default);

// Vue.component('home', require('./Dashboard').default);
// Vue.component('af_dashboard', require('./Dashboard').default);

// Vue.component("login", require("./account/login-2").default);
// Vue.component("login-carousel", require("./account/LoginCarousel").default);
// Vue.component("register", require("./account/register").default);

// Vue.component("assetflow-icons-boxicons", require("./assetflow/customers/icons/boxicons").default);
// Vue.component("assetflow-icons-dripicons", require("./assetflow/customers/icons/dripicons").default);
// Vue.component("assetflow-icons-materialdesign", require("./assetflow/customers/icons/materialdesign").default);
// Vue.component("assetflow-icons-fontawesome", require("./assetflow/customers/icons/fontawesome").default);

// Vue.component("forgot-password", require("./account/forgot-password").default);
// Vue.component("reset-password", require("./account/reset-password").default);

// Vue.component("quick_actions", require("./assetflow/AssetMenu/AddAssetMenu").default);

// Vue.component("assetflow-recycle_bin", require("./assetflow/recycle_bin/RecycleBin").default);
// Vue.component("assetflow-currencies", require("./assetflow/settings/CustomerExchangeRates").default);

// Vue.component("viewItem", require("./assetflow/items/View").default);
// Vue.component("customer-changes-scene", require("./assetflow/items/View").default);
// Vue.component("customer-overview", require("./assetflow/customers/Overview").default);
// Vue.component("assetflow-customers-assets_dashboard", require("./assetflow/customers/Dashboards/Dashboard").default);
// Vue.component("assetflow-customers-sto_dashboard", require("./assetflow/customers/Dashboards/StoDashboard").default);

// Vue.component("assetflow-addresses", require("./assetflow/customers/addresses/List").default);
// Vue.component('assetflow-addresses-new', require('./assetflow/customers/addresses/New').default);
// Vue.component('assetflow-addresses-edit', require('./assetflow/customers/addresses/New').default);


// Vue.component("assetflow-suppliers", require("./assetflow/customers/suppliers/List").default);
// Vue.component("assetflow-events", require("./assetflow/customers/events/List").default);
// Vue.component("assetflow-asset_groups", require("./assetflow/customers/asset_groups/List").default);

// Vue.component("assetflow-orders", require("./assetflow/customers/orders/List").default);
// Vue.component('assetflow-orders-new', require('./assetflow/customers/orders/New').default);
// Vue.component('assetflow-orders-edit', require('./assetflow/customers/orders/New').default);
// Vue.component('assetflow-orders-process', require('./assetflow/customers/orders/Process').default);
// Vue.component('assetflow-orders-confirm', require('./assetflow/customers/orders/ConfirmOrder').default);
// Vue.component('assetflow-order_setup', require('./assetflow/customers/orders/NotifiedUserList').default);

// Vue.component('assetflow-admin_tools', require('./assetflow/customers/managed_storages/AdminTools').default);

// Vue.component('assetflow-order_lines-new', require('./assetflow/customers/order_lines/AddOrReturnIntakeToStorage').default);
// Vue.component('assetflow-order_lines-return_to_storage', require('./assetflow/customers/order_lines/AddOrReturnIntakeToStorage').default);
// Vue.component('assetflow-order_lines-planned_assets', require('./assetflow/customers/order_lines/AddOrReturnIntakeToStorage').default);


// Vue.component('assetflow-orders-storage_orders', require('./assetflow/customers/orders/List').default);
// Vue.component('assetflow-orders-move_to_storage', require('./assetflow/customers/orders/List').default);

// Vue.component('assetflow-order_lines-storage_orders', require('./assetflow/customers/order_lines/List').default);
// Vue.component('assetflow-order_lines-move_to_storage', require('./assetflow/customers/order_lines/List').default);

// Vue.component('assetflow-managed_storages-dispatched', require('./assetflow/customers/managed_storages/List').default);
// Vue.component('assetflow-managed_storages-in_progress', require('./assetflow/customers/managed_storages/List').default);
// Vue.component('assetflow-managed_storages-in_storage', require('./assetflow/customers/managed_storages/List').default);


// Vue.component("assetflow-order_lines", require("./assetflow/customers/order_lines/List").default);
// Vue.component("assetflow-managed_storages", require("./assetflow/customers/managed_storages/List").default);
// Vue.component("assetflow-activity_logs", require("./assetflow/customers/activity_log/List").default);

// Vue.component("assetflow-bulk_updates", require("./assetflow/customers/bulk_updates/List").default);
// Vue.component("assetflow-bulk_updates-user", require("./assetflow/customers/bulk_updates/List").default);
// Vue.component("assetflow-ledgers", require("./assetflow/customers/ledgers/List").default);
// Vue.component("assetflow-ledger_groups", require("./assetflow/customers/ledger_groups/List").default);

// Vue.component("assetflow-characters", require("./assetflow/customers/characters/List").default);
// Vue.component("assetflow-sets", require("./assetflow/customers/sets/List").default);

// Vue.component("assetflow-scenes", require("./assetflow/customers/scenes/List").default);
// Vue.component("assetflow-scripts", require("./assetflow/customers/scripts/List").default);
// Vue.component("assetflow-shoot-day-live", require("./assetflow/customers/ShootDayLive/Dashboard").default);

// Vue.component("assetflow-changes", require("./assetflow/customers/changes/List").default);

// Vue.component("assetflow-scenes-costume", require("./assetflow/customers/parts_costume/List").default);
// Vue.component("assetflow-scenes-costume-new", require("./assetflow/customers/parts_costume/New").default);
// Vue.component("assetflow-scenes-costume-edit", require("./assetflow/customers/parts_costume/New").default);

// Vue.component("assetflow-parts", require("./assetflow/customers/parts/List").default);
// Vue.component("assetflow-parts-new", require("./assetflow/customers/parts/New").default);
// Vue.component("assetflow-parts-edit", require("./assetflow/customers/parts/New").default);

// Vue.component("assetflow-scene_locations", require("./assetflow/customers/scene_locations/List").default);

// Vue.component("assetflow-payments", require("./assetflow/customers/payments/List").default);
// Vue.component("assetflow-receipts", require("./assetflow/customers/receipts/List").default);

// Vue.component("assetflow-sp_warehouses", require("./assetflow/customers/sp_warehouses/List").default);
// Vue.component("assetflow-sp_spaces", require("./assetflow/customers/sp_spaces/List").default);
// Vue.component("assetflow-sp_assignments", require("./assetflow/customers/sp_assignments/List").default);

// Vue.component("assetflow-sp_storages", require("./assetflow/customers/sp_storages/List").default);
// Vue.component("assetflow-sp_storage_wrappers", require("./assetflow/customers/sp_storage_wrappers/List").default);
// Vue.component("assetflow-sp_locations", require("./assetflow/customers/sp_locations/List").default);
// Vue.component("assetflow-sp_location_types", require("./assetflow/customers/sp_location_types/List").default);

// Vue.component("assetflow-sp_movements", require("./assetflow/customers/sp_movements/List").default);

// Vue.component("assetflow-files", require("./assetflow/customers/files/List").default);
// Vue.component("assetflow-file_imports", require("./assetflow/customers/file_imports/List").default);

// Vue.component("group-asset_passports", require("./assetflow/customers/asset_passports/List").default);
// Vue.component("assetflow-asset_passports", require("./assetflow/customers/asset_passports/List").default);


// Vue.component("assetflow-departments", require("./assetflow/customers/departments/List").default);


// Vue.component("assetflow-purchaseOrders", require("./assetflow/customers/purchaseOrders/List").default);
// Vue.component("assetflow-purchaseOrders-new", require("./assetflow/customers/purchaseOrders/New").default);
// Vue.component('assetflow-purchaseOrders-edit', require('./assetflow/customers/purchaseOrders/New').default);
// Vue.component('assetflow-settings', require('./assetflow/customers/settings/SettingsTabs').default);
// Vue.component('group-settings', require('./assetflow/customers/settings/GroupSettingsTabs').default);

// Vue.component("assetflow-acquisitions", require("./assetflow/customers/acquisitions/List").default);
// Vue.component('assetflow-acquisitions-new', require('./assetflow/customers/acquisitions/New').default);
// Vue.component('assetflow-acquisitions-edit', require('./assetflow/customers/acquisitions/New').default);

// Vue.component("assetflow-dispositions", require("./assetflow/customers/dispositions/List").default);

// Vue.component("assetflow-tags", require("./assetflow/customers/tags/List").default);
// Vue.component("assetflow-folders", require("./assetflow/customers/folders/List").default);
// Vue.component("assetflow-categories", require("./assetflow/customers/categories/List").default);

// Vue.component("assetflow-policies", require("./assetflow/customers/policies/List").default);
// Vue.component("assetflow-policies-new", require("./assetflow/customers/policies/AddPolicyForm").default);


// Vue.component("assetflow-listView", require("./assetflow/ListViewTest").default);
// Vue.component("htmlRenderer", require("./assetflow/HtmlRenderer").default);
// Vue.component("tristHtmlRenderer", require("./assetflow/TristHtmlRenderer").default);
// Vue.component("formTemplate", require("./assetflow/templates/AssetFormTemplate").default);
// Vue.component("chartTest", require("./assetflow/ChartTest").default);



// Vue.component('assetflow-assets-status', require('./assetflow/assets/List').default);
// Vue.component('assetflow-assets-folders', require('./assetflow/assets/List').default);

// Vue.component('assetflow-assetsNoTabs', require('./assetflow/assets/ListNoTabs').default);
// Vue.component('assetflow-assets', require('./assetflow/assets/List').default);
// Vue.component('assetflow-olderassets', require('./assetflow/assets/List-OLD').default);

// Vue.component("assetflow-aflogs", require("./assetflow/aflogs/List").default);


// Vue.component('assetflow-customers', require('./assetflow/customers/List').default);
// Vue.component('assetflow-service_providers', require('./assetflow/service_providers/List').default);

// Vue.component('assetflow-users', require('./assetflow/users/List').default);
// Vue.component('assetflow-buyers', require('./assetflow/customers/buyers/List').default);

// Vue.component('assetflow-roles', require('./assetflow/roles/List').default);
// Vue.component('assetflow-modules', require('./assetflow/modules/List').default);
// Vue.component('assetflow-templates', require('./assetflow/file_templates/List').default);


// Vue.component('sp-assets', require('./assetflow/assets/List').default);
// Vue.component('sp-customers', require('./assetflow/customers/List').default);
// Vue.component('sp-users', require('./assetflow/users/List').default);
// Vue.component('sp-roles', require('./assetflow/roles/List').default);

// Vue.component('sp-roles-edit', require('./assetflow/roles/New').default);

// Vue.component('assetflow-switch', require('./account/switch').default);
// Vue.component('group-switch', require('./account/switch').default);
// Vue.component('character-switch', require('./account/switch').default);


// Vue.component('assetflow-roles-new', require('./assetflow/roles/New').default);
// Vue.component('assetflow-roles-edit', require('./assetflow/roles/New').default);
// Vue.component('assetflow-roles-view', require('./assetflow/roles/View').default);
// Vue.component('assetflow-roles-permissions', require('./assetflow/roles/PermissionsList').default);


// Vue.component('assetflow-users-new_user', require('./assetflow/users/New').default);
// Vue.component('assetflow-users-new', require('./assetflow/users/Add').default);
// Vue.component('assetflow-users-edit', require('./assetflow/users/New').default);
// Vue.component('assetflow-users-view', require('./assetflow/users/View').default);


// Vue.component('assetflow-assets-csv_import', require('./assetflow/assets/CsvImport').default);

// Vue.component('assetflow-assets-new-older', require('./assetflow/assets/New-old').default);
// Vue.component('assetflow-assets-edit-older', require('./assetflow/assets/New-old').default);

// Vue.component('assetflow-assets-new', require('./assetflow/assets/New').default);

// Vue.component('assetflow-assets-new_asset', require('./assetflow/assets/NewAssetOrBulkPhotoUpload').default);
// Vue.component('assetflow-assets-edit_asset', require('./assetflow/assets/EditAsset.vue').default);
// Vue.component('assetflow-assets-bulk_photo_upload', require('./assetflow/assets/NewAssetOrBulkPhotoUpload').default);
// Vue.component('assetflow-assets-image_files_upload', require('./assetflow/assets/NewAssetOrBulkPhotoUpload').default);
// Vue.component('assetflow-assets-upload_assets', require('./assetflow/assets/NewAssetOrBulkPhotoUpload').default);


// Vue.component('assetflow-acquisitions-new_acquisition', require('./assetflow/customers/acquisitions/NewAssetAcquisition').default);
// Vue.component('assetflow-assets-edit', require('./assetflow/assets/New').default);
// Vue.component('assetflow-assets-admin_new', require('./assetflow/assets/NewAdmin').default);
// Vue.component('assetflow-assets-admin_edit', require('./assetflow/assets/NewAdmin').default);


// Vue.component('assetflow-customers-new', require('./assetflow/customers/New').default);
// Vue.component('assetflow-customers-edit', require('./assetflow/customers/New').default);
// Vue.component('assetflow-customer-view', require('./assetflow/customers/View').default);


// Vue.component('assetflow-groups', require('./assetflow/groups/List').default);
// Vue.component('assetflow-groups-new', require('./assetflow/groups/New').default);
// Vue.component('assetflow-groups-edit', require('./assetflow/groups/New').default);

// Vue.component('assetflow-customer-sp', require('./assetflow/items/View').default);


// Vue.component('assetflow-service_providers-new', require('./assetflow/service_providers/New').default);
// Vue.component('assetflow-service_providers-edit', require('./assetflow/service_providers/New').default);
// Vue.component('assetflow-service_providers-view', require('./assetflow/service_providers/View').default);

// Vue.component('bss-assets', require('./assetflow/assets/List').default);


// Vue.component('profile', require('./account/profile').default);
// Vue.component('my_roles', require('./account/my_roles').default);
// Vue.component('lockscreen', require('./account/lockscreen').default);
// Vue.component('new_signup_wizard', require('./account/FirstLoginWizard').default);
// // Vue.component('show_object', require('./assetflow/ShowObject').default);

// Vue.component('shall_select_module', require('./account/SelectAModule').default);



// Vue.component('assetflow-sustainability', require('./sustain/Sustainability').default);


// Vue.component('group-assets', require('./assetflow/assets/GroupAssets').default);
// Vue.component('group-customers', require('./assetflow/customers/List').default);
// Vue.component("group-recycle_bin", require("./assetflow/recycle_bin/RecycleBin").default);



// Vue.component('home', () => import(/* webpackChunkName: "dashboard" */ './Dashboard').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('login', () => import(/* webpackChunkName: "account_login_2" */ './account/login-2').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('login-carousel', () => import(/* webpackChunkName: "account_logincarousel" */ './account/LoginCarousel').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('register', () => import(/* webpackChunkName: "account_register" */ './account/register').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('forgot-password', () => import(/* webpackChunkName: "account_forgot_password" */ './account/forgot-password').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('reset-password', () => import(/* webpackChunkName: "account_reset_password" */ './account/reset-password').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('viewItem', () => import(/* webpackChunkName: "assetflow_items_view" */ './assetflow/items/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('customer-overview', () => import(/* webpackChunkName: "assetflow_customers_overview" */ './assetflow/customers/Overview').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customers-assets_dashboard', () => import(/* webpackChunkName: "assetflow_customers_dashboards_dashboard" */ './assetflow/customers/Dashboards/Dashboard').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customers-sto_dashboard', () => import(/* webpackChunkName: "assetflow_customers_dashboards_stodashboard" */ './assetflow/customers/Dashboards/StoDashboard').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-addresses', () => import(/* webpackChunkName: "assetflow_customers_addresses_list" */ './assetflow/customers/addresses/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-addresses-new', () => import(/* webpackChunkName: "assetflow_customers_addresses_new" */ './assetflow/customers/addresses/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-addresses-edit', () => import(/* webpackChunkName: "assetflow_customers_addresses_new" */ './assetflow/customers/addresses/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-suppliers', () => import(/* webpackChunkName: "assetflow_customers_suppliers_list" */ './assetflow/customers/suppliers/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-events', () => import(/* webpackChunkName: "assetflow_customers_events_list" */ './assetflow/customers/events/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-asset_groups', () => import(/* webpackChunkName: "assetflow_customers_asset_groups_list" */ './assetflow/customers/asset_groups/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-orders', () => import(/* webpackChunkName: "assetflow_customers_orders_list" */ './assetflow/customers/orders/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-orders-new', () => import(/* webpackChunkName: "assetflow_customers_orders_new" */ './assetflow/customers/orders/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-orders-edit', () => import(/* webpackChunkName: "assetflow_customers_orders_new" */ './assetflow/customers/orders/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-orders-process', () => import(/* webpackChunkName: "assetflow_customers_orders_process" */ './assetflow/customers/orders/Process').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-order_lines', () => import(/* webpackChunkName: "assetflow_customers_order_lines_list" */ './assetflow/customers/order_lines/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-managed_storages', () => import(/* webpackChunkName: "assetflow_customers_managed_storages_list" */ './assetflow/customers/managed_storages/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-activity_logs', () => import(/* webpackChunkName: "assetflow_customers_activity_log_list" */ './assetflow/customers/activity_log/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-nominal_codes', () => import(/* webpackChunkName: "assetflow_customers_nominal_codes_list" */ './assetflow/customers/nominal_codes/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-payments', () => import(/* webpackChunkName: "assetflow_customers_payments_list" */ './assetflow/customers/payments/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-receipts', () => import(/* webpackChunkName: "assetflow_customers_receipts_list" */ './assetflow/customers/receipts/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('group-asset_passports', () => import(/* webpackChunkName: "assetflow_customers_asset_passports_list" */ './assetflow/customers/asset_passports/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-asset_passports', () => import(/* webpackChunkName: "assetflow_customers_asset_passports_list" */ './assetflow/customers/asset_passports/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-intakes', () => import(/* webpackChunkName: "assetflow_customers_intakes_list" */ './assetflow/customers/intakes/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-departments', () => import(/* webpackChunkName: "assetflow_customers_departments_list" */ './assetflow/customers/departments/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-purchaseOrders', () => import(/* webpackChunkName: "assetflow_customers_purchaseorders_list" */ './assetflow/customers/purchaseOrders/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-purchaseOrders-new', () => import(/* webpackChunkName: "assetflow_customers_purchaseorders_new" */ './assetflow/customers/purchaseOrders/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-purchaseOrders-edit', () => import(/* webpackChunkName: "assetflow_customers_purchaseorders_new" */ './assetflow/customers/purchaseOrders/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-settings', () => import(/* webpackChunkName: "assetflow_customers_settings_settingstabs" */ './assetflow/customers/settings/SettingsTabs').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('group-settings', () => import(/* webpackChunkName: "assetflow_customers_settings_groupsettingstabs" */ './assetflow/customers/settings/GroupSettingsTabs').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-acquisitions', () => import(/* webpackChunkName: "assetflow_customers_acquisitions_list" */ './assetflow/customers/acquisitions/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-acquisitions-new', () => import(/* webpackChunkName: "assetflow_customers_acquisitions_new" */ './assetflow/customers/acquisitions/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-acquisitions-edit', () => import(/* webpackChunkName: "assetflow_customers_acquisitions_new" */ './assetflow/customers/acquisitions/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-dispositions', () => import(/* webpackChunkName: "assetflow_customers_dispositions_list" */ './assetflow/customers/dispositions/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-tags', () => import(/* webpackChunkName: "assetflow_tags_list" */ './assetflow/tags/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-listView', () => import(/* webpackChunkName: "assetflow_listviewtest" */ './assetflow/ListViewTest').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('htmlRenderer', () => import(/* webpackChunkName: "assetflow_htmlrenderer" */ './assetflow/HtmlRenderer').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('tristHtmlRenderer', () => import(/* webpackChunkName: "assetflow_tristhtmlrenderer" */ './assetflow/TristHtmlRenderer').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('formTemplate', () => import(/* webpackChunkName: "assetflow_templates_assetformtemplate" */ './assetflow/templates/AssetFormTemplate').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('chartTest', () => import(/* webpackChunkName: "assetflow_charttest" */ './assetflow/ChartTest').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-status', () => import(/* webpackChunkName: "assetflow_assets_list" */ './assetflow/assets/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-folders', () => import(/* webpackChunkName: "assetflow_assets_list" */ './assetflow/assets/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assetsNoTabs', () => import(/* webpackChunkName: "assetflow_assets_listnotabs" */ './assetflow/assets/ListNoTabs').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets', () => import(/* webpackChunkName: "assetflow_assets_list" */ './assetflow/assets/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-olderassets', () => import(/* webpackChunkName: "assetflow_assets_list_old" */ './assetflow/assets/List-OLD').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-aflogs', () => import(/* webpackChunkName: "assetflow_aflogs_list" */ './assetflow/aflogs/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-folders', () => import(/* webpackChunkName: "assetflow_folders_list" */ './assetflow/folders/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customers', () => import(/* webpackChunkName: "assetflow_customers_list" */ './assetflow/customers/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-service_providers', () => import(/* webpackChunkName: "assetflow_service_providers_list" */ './assetflow/service_providers/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-users', () => import(/* webpackChunkName: "assetflow_users_list" */ './assetflow/users/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-roles', () => import(/* webpackChunkName: "assetflow_roles_list" */ './assetflow/roles/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('sp-assets', () => import(/* webpackChunkName: "assetflow_assets_list" */ './assetflow/assets/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('sp-customers', () => import(/* webpackChunkName: "assetflow_customers_list" */ './assetflow/customers/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('sp-users', () => import(/* webpackChunkName: "assetflow_users_list" */ './assetflow/users/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('sp-roles', () => import(/* webpackChunkName: "assetflow_roles_list" */ './assetflow/roles/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('sp-roles-edit', () => import(/* webpackChunkName: "assetflow_roles_new" */ './assetflow/roles/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-switch', () => import(/* webpackChunkName: "account_switch" */ './account/switch').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('group-switch', () => import(/* webpackChunkName: "account_switch" */ './account/switch').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-roles-new', () => import(/* webpackChunkName: "assetflow_roles_new" */ './assetflow/roles/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-roles-edit', () => import(/* webpackChunkName: "assetflow_roles_new" */ './assetflow/roles/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-roles-view', () => import(/* webpackChunkName: "assetflow_roles_view" */ './assetflow/roles/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-roles-permissions', () => import(/* webpackChunkName: "assetflow_roles_permissionslist" */ './assetflow/roles/PermissionsList').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-users-new', () => import(/* webpackChunkName: "assetflow_users_new" */ './assetflow/users/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-users-edit', () => import(/* webpackChunkName: "assetflow_users_new" */ './assetflow/users/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-users-view', () => import(/* webpackChunkName: "assetflow_users_view" */ './assetflow/users/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-csv_import', () => import(/* webpackChunkName: "assetflow_assets_csvimport" */ './assetflow/assets/CsvImport').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-new-older', () => import(/* webpackChunkName: "assetflow_assets_new_old" */ './assetflow/assets/New-old').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-edit-older', () => import(/* webpackChunkName: "assetflow_assets_new_old" */ './assetflow/assets/New-old').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-new', () => import(/* webpackChunkName: "assetflow_assets_new" */ './assetflow/assets/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-edit', () => import(/* webpackChunkName: "assetflow_assets_new" */ './assetflow/assets/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-admin_new', () => import(/* webpackChunkName: "assetflow_assets_newadmin" */ './assetflow/assets/NewAdmin').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-assets-admin_edit', () => import(/* webpackChunkName: "assetflow_assets_newadmin" */ './assetflow/assets/NewAdmin').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customers-new', () => import(/* webpackChunkName: "assetflow_customers_new" */ './assetflow/customers/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customers-edit', () => import(/* webpackChunkName: "assetflow_customers_new" */ './assetflow/customers/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customer-view', () => import(/* webpackChunkName: "assetflow_customers_view" */ './assetflow/customers/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-groups', () => import(/* webpackChunkName: "assetflow_groups_list" */ './assetflow/groups/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-groups-new', () => import(/* webpackChunkName: "assetflow_groups_new" */ './assetflow/groups/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-groups-edit', () => import(/* webpackChunkName: "assetflow_groups_new" */ './assetflow/groups/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-customer-sp', () => import(/* webpackChunkName: "assetflow_items_view" */ './assetflow/items/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-service_providers-new', () => import(/* webpackChunkName: "assetflow_service_providers_new" */ './assetflow/service_providers/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-service_providers-edit', () => import(/* webpackChunkName: "assetflow_service_providers_new" */ './assetflow/service_providers/New').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-service_providers-view', () => import(/* webpackChunkName: "assetflow_service_providers_view" */ './assetflow/service_providers/View').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('bss-assets', () => import(/* webpackChunkName: "assetflow_assets_list" */ './assetflow/assets/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('profile', () => import(/* webpackChunkName: "account_profile" */ './account/profile').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('lockscreen', () => import(/* webpackChunkName: "account_lockscreen" */ './account/lockscreen').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('new_signup_wizard', () => import(/* webpackChunkName: "account_firstloginwizard" */ './account/FirstLoginWizard').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('assetflow-sustainability', () => import(/* webpackChunkName: "sustain_sustainability" */ './sustain/Sustainability').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('group-assets', () => import(/* webpackChunkName: "assetflow_assets_groupassets" */ './assetflow/assets/GroupAssets').then((AsyncComponent) => { resolve(AsyncComponent.default); }));
//
// Vue.component('group-customers', () => import(/* webpackChunkName: "assetflow_customers_list" */ './assetflow/customers/List').then((AsyncComponent) => { resolve(AsyncComponent.default); }));





// Vue.component('home', (resolve) => {
//     import('./Dashboard')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('login', (resolve) => {
//     import('./account/login-2')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('login-carousel', (resolve) => {
//     import('./account/LoginCarousel')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('register', (resolve) => {
//     import('./account/register')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('forgot-password', (resolve) => {
//     import('./account/forgot-password')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('reset-password', (resolve) => {
//     import('./account/reset-password')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('viewItem', (resolve) => {
//     import('./assetflow/items/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('customer-overview', (resolve) => {
//     import('./assetflow/customers/Overview')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-customers-assets_dashboard', (resolve) => {
//     import('./assetflow/customers/Dashboards/Dashboard')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-customers-sto_dashboard', (resolve) => {
//     import('./assetflow/customers/Dashboards/StoDashboard')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-addresses', (resolve) => {
//     import('./assetflow/customers/addresses/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-addresses-new', (resolve) => {
//     import('./assetflow/customers/addresses/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-addresses-edit', (resolve) => {
//     import('./assetflow/customers/addresses/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-suppliers', (resolve) => {
//     import('./assetflow/customers/suppliers/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-events', (resolve) => {
//     import('./assetflow/customers/events/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-asset_groups', (resolve) => {
//     import('./assetflow/customers/asset_groups/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-orders', (resolve) => {
//     import('./assetflow/customers/orders/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-orders-new', (resolve) => {
//     import('./assetflow/customers/orders/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-orders-edit', (resolve) => {
//     import('./assetflow/customers/orders/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-orders-process', (resolve) => {
//     import('./assetflow/customers/orders/Process')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-order_lines', (resolve) => {
//     import('./assetflow/customers/order_lines/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-managed_storages', (resolve) => {
//     import('./assetflow/customers/managed_storages/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-activity_logs', (resolve) => {
//     import('./assetflow/customers/activity_log/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-nominal_codes', (resolve) => {
//     import('./assetflow/customers/nominal_codes/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-payments', (resolve) => {
//     import('./assetflow/customers/payments/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-receipts', (resolve) => {
//     import('./assetflow/customers/receipts/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('group-asset_passports', (resolve) => {
//     import('./assetflow/customers/asset_passports/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-asset_passports', (resolve) => {
//     import('./assetflow/customers/asset_passports/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-intakes', (resolve) => {
//     import('./assetflow/customers/intakes/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-departments', (resolve) => {
//     import('./assetflow/customers/departments/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-purchaseOrders', (resolve) => {
//     import('./assetflow/customers/purchaseOrders/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-purchaseOrders-new', (resolve) => {
//     import('./assetflow/customers/purchaseOrders/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-purchaseOrders-edit', (resolve) => {
//     import('./assetflow/customers/purchaseOrders/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-settings', (resolve) => {
//     import('./assetflow/customers/settings/SettingsTabs')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('group-settings', (resolve) => {
//     import('./assetflow/customers/settings/GroupSettingsTabs')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-acquisitions', (resolve) => {
//     import('./assetflow/customers/acquisitions/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-acquisitions-new', (resolve) => {
//     import('./assetflow/customers/acquisitions/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-acquisitions-edit', (resolve) => {
//     import('./assetflow/customers/acquisitions/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-dispositions', (resolve) => {
//     import('./assetflow/customers/dispositions/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-tags', (resolve) => {
//     import('./assetflow/tags/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-listView', (resolve) => {
//     import('./assetflow/ListViewTest')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('htmlRenderer', (resolve) => {
//     import('./assetflow/HtmlRenderer')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('tristHtmlRenderer', (resolve) => {
//     import('./assetflow/TristHtmlRenderer')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('formTemplate', (resolve) => {
//     import('./assetflow/templates/AssetFormTemplate')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('chartTest', (resolve) => {
//     import('./assetflow/ChartTest')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
//
// Vue.component('assetflow-assets-status', (resolve) => {
//     import('./assetflow/assets/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets-folders', (resolve) => {
//     import('./assetflow/assets/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-assetsNoTabs', (resolve) => {
//     import('./assetflow/assets/ListNoTabs')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets', (resolve) => {
//     import('./assetflow/assets/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-olderassets', (resolve) => {
//     import('./assetflow/assets/List-OLD')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-aflogs', (resolve) => {
//     import('./assetflow/aflogs/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-folders', (resolve) => {
//     import('./assetflow/folders/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-customers', (resolve) => {
//     import('./assetflow/customers/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-service_providers', (resolve) => {
//     import('./assetflow/service_providers/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-users', (resolve) => {
//     import('./assetflow/users/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-roles', (resolve) => {
//     import('./assetflow/roles/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('sp-assets', (resolve) => {
//     import('./assetflow/assets/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('sp-customers', (resolve) => {
//     import('./assetflow/customers/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('sp-users', (resolve) => {
//     import('./assetflow/users/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('sp-roles', (resolve) => {
//     import('./assetflow/roles/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('sp-roles-edit', (resolve) => {
//     import('./assetflow/roles/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-switch', (resolve) => {
//     import('./account/switch')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('group-switch', (resolve) => {
//     import('./account/switch')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-roles-new', (resolve) => {
//     import('./assetflow/roles/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-roles-edit', (resolve) => {
//     import('./assetflow/roles/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-roles-view', (resolve) => {
//     import('./assetflow/roles/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-roles-permissions', (resolve) => {
//     import('./assetflow/roles/PermissionsList')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-users-new', (resolve) => {
//     import('./assetflow/users/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-users-edit', (resolve) => {
//     import('./assetflow/users/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-users-view', (resolve) => {
//     import('./assetflow/users/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-assets-csv_import', (resolve) => {
//     import('./assetflow/assets/CsvImport')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-assets-new-older', (resolve) => {
//     import('./assetflow/assets/New-old')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets-edit-older', (resolve) => {
//     import('./assetflow/assets/New-old')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-assets-new', (resolve) => {
//     import('./assetflow/assets/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets-edit', (resolve) => {
//     import('./assetflow/assets/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets-admin_new', (resolve) => {
//     import('./assetflow/assets/NewAdmin')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-assets-admin_edit', (resolve) => {
//     import('./assetflow/assets/NewAdmin')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-customers-new', (resolve) => {
//     import('./assetflow/customers/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-customers-edit', (resolve) => {
//     import('./assetflow/customers/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-customer-view', (resolve) => {
//     import('./assetflow/customers/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-groups', (resolve) => {
//     import('./assetflow/groups/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-groups-new', (resolve) => {
//     import('./assetflow/groups/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-groups-edit', (resolve) => {
//     import('./assetflow/groups/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('assetflow-customer-sp', (resolve) => {
//     import('./assetflow/items/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('assetflow-service_providers-new', (resolve) => {
//     import('./assetflow/service_providers/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-service_providers-edit', (resolve) => {
//     import('./assetflow/service_providers/New')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('assetflow-service_providers-view', (resolve) => {
//     import('./assetflow/service_providers/View')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('bss-assets', (resolve) => {
//     import('./assetflow/assets/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
// Vue.component('profile', (resolve) => {
//     import('./account/profile')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('lockscreen', (resolve) => {
//     import('./account/lockscreen')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('new_signup_wizard', (resolve) => {
//     import('./account/FirstLoginWizard')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
//
//
// Vue.component('assetflow-sustainability', (resolve) => {
//     import('./sustain/Sustainability')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
//
// Vue.component('group-assets', (resolve) => {
//     import('./assetflow/assets/GroupAssets')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
//
//
// Vue.component('group-customers', (resolve) => {
//     import('./assetflow/customers/List')
//         .then((AsyncComponent) => {
//             resolve(AsyncComponent.default);
//         });
// });
